import Service from './Service.js';
import debounce from '../utils/debounce.js';

class Resize extends Service {
  init() {
    this.handler = debounce(() => {
      this.trigger(this.props);
    }).bind(this);
    window.addEventListener('resize', this.handler);
    return this;
  }

  kill() {
    window.removeEventListener('resize', this.handler);
    return this;
  }

  get props() {
    var props = {
      width: window.innerWidth,
      height: window.innerHeight,
      ratio: window.innerWidth / window.innerHeight,
      orientation: 'square'
    };

    if (props.ratio > 1) {
      props.orientation = 'landscape';
    }

    if (props.ratio < 1) {
      props.orientation = 'portrait';
    }

    if (this.breakpointElement) {
      props.breakpoint = this.breakpoint;
      props.breakpoints = this.breakpoints;
    }

    return props;
  }

  get breakpointElement() {
    return document.querySelector('[data-breakpoint]') || null;
  }

  get breakpoint() {
    return window.getComputedStyle(this.breakpointElement, '::before').getPropertyValue('content').replace(/"/g, '');
  }

  get breakpoints() {
    var breakpoints = window.getComputedStyle(this.breakpointElement, '::after').getPropertyValue('content').replace(/"/g, '');
    return breakpoints.split(',');
  }

}

var resize = null;
export default function useResize() {
  if (!resize) {
    resize = new Resize();
  }

  var add = resize.add.bind(resize);
  var remove = resize.remove.bind(resize);
  var has = resize.has.bind(resize);

  var props = () => resize.props;

  return {
    add,
    remove,
    has,
    props
  };
}